module.exports = __webpack_public_path__ + "img/70038.b963ab25.png";